<template>
  <v-app>
    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="#0072AC" dark app flat v-if="isLogin"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down"><strong>Yaku</strong>SeLA</span> <small>v1.0</small>
      </v-toolbar-title>
<!--      <h1 style="color:red">SISTEMA DE PRUEBA</h1>-->
      <v-spacer/>

      <v-btn icon @click="logout" title="Salir del sistema">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app v-if="isLogin"
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="indigo">
            <img v-if="usuario.funcionario.foto === null" src="./assets/images/yaku-user.png" alt="foto"/>
            <img v-else :src="usuario.funcionario.foto" alt="foto">
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ usuario.nombre_completo }}</v-list-item-title>
          <v-list-item-subtitle>{{ usuario.funcionario.ci }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list shaped>
        <v-list-item :to="{name:'Home'}" exact>
          <v-list-item-icon>
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Aplicacciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'MiPerfil'}" exact>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Mi Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'CambiarPassword'}" exact>
          <v-list-item-icon>
            <v-icon>mdi-lock-reset</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Cambiar Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name:'About'}" exact>
          <v-list-item-icon>
            <v-icon>mdi-laptop</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Acerca de</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" color="#0072AC" dark block>Salir del Sistema</v-btn>
        </div>
      </template>

    </v-navigation-drawer>

    <v-main>
      <v-container class="fill-height"
                   fluid grid-list-xl style="background-color: #F4F8F9">

        <v-layout align="center"
                  justify="center" wrap>
          <v-flex md12>
            <router-view :key="$route.fullPath"></router-view>
          </v-flex>
        </v-layout>

      </v-container>
    </v-main>


    <v-footer padless app v-if="isLogin">
      <v-col
          class="text-center"
          cols="12"
      >
        <strong>SeLA</strong> - Oruro
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'App',
  data: () => ({
    drawer: true,
    visible: false,
    windowSize: '',
    contador: 0,
  }),
  created() {
  },
  mounted() {
  },
  methods: {
    logout() {
      this.$funciones.confirm(this.$swal, "Vas a salir definitivamente del sistema",).then(result => {
        if (result.value) {
          this.salirDelSistema();
        }
      });
    },
    salirDelSistema() {
      this.$store.dispatch("destroyToken").then(response => {
        this.$router.push({name: "login"});
      }).catch(e => {
        console.log(e.response);
      });
    },
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapState(['url_base', 'token', 'usuario', 'sistemas'])
  }
};
</script>

<style scope>
.router-link-active {
  font-weight: bold;
}
</style>
